import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { workAdvisoryKeys } from "@/lib/query-keys";
import type { EntityCompetition } from "@/types/workadvisory";

/**
 * El histórico de adjudicaciones de la entidad. `enabled` a pedido: en un informe
 * de 10 obras no tiene sentido pedir 10 históricos que quizá nadie abra.
 */
export function useEntityCompetition(contractingId: number, enabled: boolean) {
  return useQuery({
    queryKey: workAdvisoryKeys.competition(contractingId),
    enabled,
    queryFn: async () => {
      const res = await fetchToBackend<{ data: EntityCompetition }>(
        `/admin/work-advisory/competition/${contractingId}`,
      );
      return res.data;
    },
  });
}
